<style lang="sass" scoped>
.p-main
    padding: 20px 20px 0
    .part-title
        height: 35px
        line-height: 34px
        margin-bottom: 0
        .help
            font-size: 14px
            cursor: pointer
            color: #999
            float: right
            i
                margin-right: 5px

        &.back
            margin-bottom: 30px
            .fr
                color: #FF3973
                width: 100px
                height: 30px
                line-height: 30px
                border: 1px solid #FF3973
                border-radius: 4px
                font-size: 14px
                text-align: center
                cursor: pointer
.commission
    .commission-top
        margin-bottom: 12px
    .commision-top-left
        width: 340px
        height: 120px
        background: linear-gradient(135deg, rgba(216, 202, 154, 0.5) 0%, rgba(196, 171, 130, 0.5) 100%)
        border-radius: 10px
        padding: 20px
        img
            width: 80px
            height: 80px
            border-radius: 50%
        .left-box
            margin-top: 20px
            border-left: 1px solid #fff
            height: 40px
            margin-left: 20px
            padding-left: 20px
            font-weight: 600
            font-size: 16px
            > div
                position: relative
                top: -25px
            .fee
                font-size: 28px
                line-height: 50px
                i
                    font-size: 20px
                    font-style: normal
            span
                opacity: 0.5
                font-weight: 500
                &.small
                    font-size: 12px

    .commission-top-right
        width: calc(100% - 360px)
        background: #f5f5f5
        border-radius: 10px
        padding: 40px 0
        height: 120px
        overflow: hidden
        text-align: center
        > div
            float: left
            height: 40px
        .ul
            width: 120px
            padding: 0 45px
            .li
                color: #999
                margin: 10px 0
                cursor: pointer
                position: relative
                top: -28px
                &.cur
                    color: #282729
                    border-bottom: 1px solid #282729
                    font-weight: 600
        .box
            width: calc(50% - 60px)
            border-left: 1px solid #d4d4d4
            font-size: 16px
            font-weight: 400
            > div
                margin-top: -5px
            span
                font-weight: 600
                font-size: 28px
                line-height: 40px
                &.small
                    font-size: 20px

    .list
        height: calc(100%)
.cs-tabs
    overflow: hidden
    .cs-tab
        float: left
        width: 160px
        height: 40px
        line-height: 40px
        background: #fff
        border: 1px solid #e9e9e9
        border-bottom: none
        border-radius: 4px 4px 0 0
        margin-right: 20px
        cursor: pointer
        text-align: center
        &.cur
            border: none
            background: linear-gradient(315deg, rgba(250, 234, 97, .6) 0%, rgba(255, 184, 31, .6) 100%)
            border-radius: 4px 4px 0px 0px
.cs-help-ctn
    border: 1px solid #e9e9e9
    height: calc(100% - 125px)
    padding: 20px
    .box
        margin-bottom: 10px
        > div
            padding: 10px 20px
    .hp-title
        font-size: 16px
        line-height: 22px
        font-weight: 600
        border: 1px solid #e9e9e9
        cursor: pointer
    .hp-list
        background: #f5f5f5
        .q
            font-weight: 600
            margin-top: 10px
            margin-bottom: 5px
        .a + .a
            margin-top: 10px
.commission_main
    position: relative
    height: calc(100% - 132px)
    .help
        position: absolute
        top: 10px
        right: 0
        z-index: 1
        cursor: pointer
    .el_tabs_main
        height: 100%
        ::v-deep .el-tabs__nav
            border: none
        ::v-deep .el-tabs__content
            height: calc(100% - 42px)
            border: 1px solid #E9E9E9
            border-top: 0
        ::v-deep .el-tabs__header
            margin-bottom: 0
            .el-tabs__item
                width: 160px
                text-align: center
                font-size: 16px
                margin-right: 10px
                border: 1px solid #E9E9E9
                border-radius: 4px 4px 0 0
            .is-active
                background: linear-gradient(315deg, rgba(250, 234, 97, 1) 0%, rgba(255, 184, 31, 1) 100%)
                color: #282729
                font-weight: bolder
        .page_box
            margin-left: 20px
    .friend_num
        overflow: hidden
        text-align: center
        font-size: 16px
        color: #666666
        padding: 26px 0 26px
        border-bottom: 1px solid #E9E9E9
        .tab
            float: left
            width: 50%
            &:first-child
                border-right: 1px solid #D4D4D4
            .num
                line-height: 40px
                margin-bottom: 5px
                color: #282729
                font-size: 32px
                font-weight: 600
                i
                    font-size: 22px
                    font-weight: normal
</style>
<style lang="sass">
.commission
    .el-table th,
    .el-table tr
        background: #f1f1f1
</style>

<template lang="pug">

    .commission
        .p-title 我的佣金
        .p-main
            template(v-if="!showHelp")
                .commission-top
                    .commision-top-left.fl
                        img.fl(src="../assets/icon-cs.png")
                        .left-box.fl
                            div
                                span 累计佣金
                                .fee.Akrobat-ExtraBold ￥{{fee(money)}}
                                    i .{{fee(money, 1)}}
                                span.small 佣金采用实时结算的方式

                    .commission-top-right.fr
                        .ul
                            .li(v-for="(item, i) in tabs" :key="i" @click="curTab=i" :class="{'cur': i == curTab}") {{item}}
                        .box
                            div 佣金金额
                            span.Akrobat-ExtraBold ￥{{fee(curMoney.totalAmount || 0)}}
                                span.small .{{fee(curMoney.totalAmount || 0, 1)}}
                        .box
                            div 订单数
                            span.Akrobat-ExtraBold {{curMoney.orderCount || 0}}

                    .clear

                div.commission_main
                    .help(@click="clickShowHelp")
                        i.iconfont.icon-bangzhu
                        | 帮助
                    el-tabs.el_tabs_main(v-model="typeIdx" type="card" @tab-click="tabChange")
                        el-tab-pane(label="佣金明细" name="1" style="height: 100%;")
                            div(style="height: calc(100% - 43px);padding-bottom: 10px")
                                el-table(:data="tableData" size="mini" stripe border height="100%")
                                    el-table-column(label="用户" align="center" prop="mobilePhone")
                                    el-table-column(label="所得佣金" align="center")
                                        template(slot-scope="{row}") {{row.amount ? row.amount.toFixed(2) : '0.00'}}元

                            Pagination.page_box(
                                :total="pageInfo.total" :current-page.sync="pageInfo.current"
                                :size.sync="pageInfo.size" @fn-change="getList"
                            )
                        el-tab-pane(label="邀请好友数" name="2" style="height: 100%;")
                            .friend_num
                                .tab
                                    p.num {{friendInfo.historyPercent * 100}}
                                        i %
                                    p 当前佣金比例
                                .tab
                                    p.num {{friendInfo.partnerSum}}
                                    p 已邀请好友数
                            div(style="height: calc(100% - 186px);margin: 10px")
                                el-table(:data="tableData" size="mini" stripe border height="100%")
                                    el-table-column(label="我邀请的好友" align="center" prop="mobilePhone")
                                    el-table-column(label="注册时间" align="center" prop="createTime")
                                    el-table-column(label="累计消费" align="center")
                                        template(slot-scope="{row}") {{row.money ? row.money.toFixed(2) : '0.00'}}元
                                    el-table-column(label="累计佣金" align="center")
                                        template(slot-scope="{row}") {{row.amount ? row.amount.toFixed(2) : '0.00'}}元

                            Pagination.page_box(
                                :total="pageInfo.total" :current-page.sync="pageInfo.current"
                                :size.sync="pageInfo.size" @fn-change="getFriendCountList"
                            )

            template(v-else)
                .part-title.back 帮助中心
                    .fr(@click="showHelp = false;curHelpTab = 0;")
                        i.el-icon-arrow-left
                        span 返回佣金

                .cs-tabs
                    .cs-tab(
                        v-for="(item, i) in helpTabs" :key="i"
                        @click="curHelpTab = i" :class="{'cur': curHelpTab == i}"
                    ) {{item}}
                .cs-help-ctn
                    .box(v-for="(item, i) in helps1" v-if="curHelpTab == 0")
                        .hp-title(@click="item.open = !item.open") {{item.title}}
                        .hp-list(v-show="item.open")
                            template(v-for="it in item.qas")
                                .q(v-if="it.q") {{it.q}}
                                template(v-for="answer in it.answers")
                                    .a {{answer.split('|')[0]}}
                                        template(v-if="answer.split('|')[1]")
                                            br
                                            | {{answer.split('|')[1]}}
                    .box(v-for="(item, i) in helps2" v-if="curHelpTab == 1")
                        .hp-title(@click="item.open = !item.open") {{item.title}}
                        .hp-list(v-show="item.open")
                            template(v-for="it in item.qas")
                                .q(v-if="it.q") {{it.q}}
                                template(v-for="answer in it.answers")
                                    .a {{answer}}

</template>

<script>
import Pagination from '../components/Pagination'

export default {
    name: 'commision',
    components: {Pagination},
    data () {
        return {
            typeIdx: '1',
            curTab: 0,
            tabs: ['昨日', '本月', '上月'],
            helpTabs: ['基础问题', '佣金问题'],
            money: 0,
            curMoney: {},
            tableData: [],
            pageInfo: {
                total: 0,
                current: 1,
                size: 20
            },
            showHelp: false,
            friendInfo: {
                historyPercent: 0,
                partnerSum: 0
            },
            curHelpTab: 0,
            helps1: [
                {
                    open: false,
                    title: '1.什么是合伙人？',
                    qas: [
                        {
                            q: '什么是合伙人？',
                            answers: [
                                '亲爱的梯之星合伙人们，梯之星是新再灵旗下的广告投放平台，通过分享好友赚取佣金。我们旨在培养梯之星自己的广告合伙人，通过微信等渠道，让大家轻松赚取佣金。 '
                            ]
                        },
                        {
                            q: '我们的优势',
                            answers: [
                                '1、大平台 海量广告位|梯之星以全国15个城市，覆盖一线流量资源，目前全部铺设超10万个优质终端点位，日均覆盖1亿人次，精准匹配消费人群。',
                                '2、服务完善 投放无忧|为致力于打造基于电梯场景的AI广告投放第一品牌，从投放、客服、效果全方位保障用户体验。',
                                '3、数据支持 可视化管理|可视化数据分析，实现实时数据查询，全流程提供精准数据服务，让每一个合伙人收入有据可依。 '
                            ]
                        }
                    ]
                },
                {
                    open: false,
                    title: '2.如何成为梯之星合伙人？',
                    qas: [
                        {
                            answers: [
                                '在梯之星APP中点开“我的”，点击“我的佣金”图片，填写姓名及手机等信息申请开通合伙人。 注：部分内测用户无需审核。'
                            ]
                        }
                    ]
                },
                {
                    open: false,
                    title: '3.如何进行分享？',
                    qas: [
                        {
                            answers: [
                                '在APP中点开“我的”，进入“邀请好友赚体验金”活动页，点击右下角“分享好友”按钮。'
                            ]
                        }
                    ]
                },
                {
                    open: false,
                    title: '4.可以分享到哪里？',
                    qas: [
                        {
                            answers: [
                                '可以将活动的链接发送到微信好友、朋友圈和微信群。'
                            ]
                        }
                    ]
                }
            ],
            helps2: [
                {
                    open: false,
                    title: '1.佣金模块名称解释？',
                    qas: [
                        {
                            answers: [
                                '全部佣金数据：梯之星合伙人分享产生的所有佣金订单详情。'
                            ]
                        }
                    ]
                },
                {
                    open: false,
                    title: '2.佣金比例怎么算？',
                    qas: [
                        {
                            answers: [
                                '邀请新用户下单返实付金额10%佣金。'
                            ]
                        }
                    ]
                },
                {
                    open: false,
                    title: '3.怎么做才能获取佣金？',
                    qas: [
                        {
                            answers: [
                                '当邀请的新用户下单投放广告，新用户订单支付成功后对佣金进行结算。'
                            ]
                        }
                    ]
                },
                {
                    open: false,
                    title: '4.从哪里看到我的佣金界面？',
                    qas: [
                        {
                            answers: [
                                '1、梯之星APP中点击“我的”，找到“我的佣金”图片，点击进入佣金界面。',
                                '2、梯之星系统中点击“账号中心”，找到“我的佣金”，点击进入佣金界面。'
                            ]
                        }
                    ]
                },
                {
                    open: false,
                    title: '5.为什么我分享给好友后，他下单了，我没有佣金？',
                    qas: [
                        {
                            answers: [
                                '1、没有成功申请梯之星合伙人，邀请好友下单不会得到佣金。',
                                '2、订单被撤销。'
                            ]
                        }
                    ]
                }
            ]
        }
    },
    created () {
        //- this.getList3()
        //- this.init()
    },
    watch: {
        curTab () {
            this.init()
        }
    },
    computed: {
        fee () {
            return (money, type) => {
                if (!money) return type ? '00' : 0
                let isMinus = money < 0
                if (isMinus) money = 0 - money
                if (!type) {
                    let arr = (Math.floor(money) + '').split('').reverse()
                    let a = []
                    arr.forEach((el, i) => {
                        a.push(el)
                        if ((i + 1) % 3 == 0) a.push(',')
                    })
                    let str = a.reverse().join('')
                    let data = str.charAt(0) == ',' ? str.slice(1) : str
                    return isMinus ? '-' + data : data
                } else {
                    let sp = (money + '').split('.')
                    return sp.length > 1 ? ((sp[1] + '').length == 1 ? sp[1] + '0' : sp[1]) : '00'
                }
            }
        }
    },
    methods: {
        clickShowHelp () {
          this.showHelp = true
        },
        init () {
            this.getList2()
            this.tabChange()
        },
        async getList2 () { // curMoney
            let res = await this.fetch('/boss/accounthistory/v2/getBrokerageSimpleInfo', {type: this.curTab + 1}, 'get')
            if (res && res.code == this.successCode) {
                this.curMoney = res.data || {}
            }
        },
        async getList3 () { // money
            let res = await this.fetch('/boss/accounthistory/v2/getTotalBrokerage', '', 'get')
            if (res && res.code == this.successCode) {
                this.money = res.data || 0
            }
        },
        async getList () {
            if (this.typeIdx == 2) return
            let option = {
                pageIndex: this.pageInfo.current,
                pageSize: this.pageInfo.size,
                type: this.curTab + 1, // 昨日1 本月2 上月3
            }
            let res = await this.fetch('/boss/accounthistory/v2/getBrokerageHistoryInfo', option, 'get')
            if (res && res.code == this.successCode) {
                this.tableData = res.data.list || []
                this.pageInfo.total = res.data.total || 0
            }
        },
        async getFriendCountList () {
            if (this.typeIdx == 1) return
            let option = {
                pageIndex: this.pageInfo.current,
                pageSize: this.pageInfo.size,
                type: this.curTab + 1, // 昨日1 本月2 上月3
            }
            let res = await this.fetch('/boss/accounthistory/v2/getAccountHistoryFromData', option, 'get')
            if (res && res.code == this.successCode) {
                this.friendInfo.historyPercent = res.data.historyPercent || 0
                this.friendInfo.partnerSum = res.data.partnerSum || 0
                let pageInfo = res.data.pageInfo || {}
                this.tableData = pageInfo.list || []
                this.pageInfo.total = pageInfo.total || 0
            }
        },
        tabChange () {
            // 重置页码
            if (this.pageInfo.current != 1) this.pageInfo.current = 1
            if (this.pageInfo.size != 20) this.pageInfo.size = 20

            if (this.typeIdx == 1) this.getList()
            else if (this.typeIdx == 2) this.getFriendCountList()
        }
    }
}
</script>
